import scenarios, { AuditFormPerformerGetter } from "./scenarios";

function valuesEqual(value1, value2) {
  if (Array.isArray(value1)) {
    return value1.includes(value2);
  }
  return value2 === value1;
}

function areArraysEqual(array1, array2) {
  for (const [index, obj1] of array1.entries()) {
    const obj2 = array2[index];

    if (obj1.id !== obj2.id || obj1.component !== obj2.component || !valuesEqual(obj2.value, obj1.value)) {
      return false;
    }
  }

  return true;
}

export type AuditFormType = {
  id: string;
  value: any;
  component: string;
};

export class AuditFormManager {
  scenarios: AuditFormType[][] = scenarios;
  answers: AuditFormType[] = [];
  scenarioIndex: number = 0;
  fetchAuditQuestion: Function;
  saveQuestionResponse: Function;

  constructor(fetchAuditQuestion, saveQuestionResponse) {
    this.fetchAuditQuestion = fetchAuditQuestion;
    this.saveQuestionResponse = saveQuestionResponse;

    this.init();
  }

  get current() {
    const lastAnswerIndex = this.answers.length - 1;
    return this.answers[lastAnswerIndex];
  }

  get getComponent() {
    return this.current?.component;
  }

  init() {
    const { component, id } = AuditFormPerformerGetter();

    this.fetchAuditQuestion(id);

    this.answers.push({
      id,
      component,
      value: null
    });
  }

  isSame(slice: AuditFormType[]) {
    return areArraysEqual(this.answers, slice);
  }

  storeAnswer({ value: answer }) {
    this.current.value = Number.parseInt(answer);

    for (const [index, scenario] of this.scenarios.entries()) {
      const _scenario = scenario.map(question => ({ ...question }));
      const slice = _scenario.splice(0, this.answers.length);

      if (slice.length === this.answers.length && this.isSame(slice)) {
        this.scenarioIndex = index + 1;

        break;
      }
    }
  }

  async saveAndGetNext() {
    await this.saveQuestionResponse({
      questionTypeId: this.current.id,
      option: this.current.value
    });

    const nextQuestion = this.answers.length;
    const scenario = this.scenarios[this.scenarioIndex - 1];

    if (scenario) {
      const next = scenario[nextQuestion];

      if (next) {
        const { component, id } = next;

        await this.fetchAuditQuestion(id);

        this.answers.push({
          id,
          component,
          value: null
        });
      }
    }
  }
}

export { default as AuditFormPerformer } from "./AuditFormPerformer.vue";
export { default as AuditFormSharedCredentials } from "./AuditFormSharedCredentials.vue";
export { default as AuditFormPaymentType } from "./AuditFormPaymentType.vue";
export { default as AuditFormRealizedAllProcedures } from "./AuditFormRealizedAllProcedures.vue";
export { default as AuditFormConfirmButtons } from "./ConfirmButtons.vue";
